import React from 'react'
import { Input } from 'antd'
import BatchesPartner from './BatchesPartner'
import FilterDateRangeV2 from '../../../home/components/filters/FilterDateRangeV2'
import FilterProductType from './FilterProductType'
import SelectFilterOptions from '../../../shared/SelectFilterOptions'
import { Select } from "antd"
import {TAGS} from "./ListOptions"


const { Option } = Select
const { Search } = Input

const FilterItemPieceError = (props) => {
    const {
        partner,
        priority,
        productTypes,
        startCreate,
        handleChangeName,
        handleChangeProductType,
        handleChageUserCreate,
        handleChangePartner,
        handleChagePriority,
        handleChangeDate,
        listBrand,
        brand, batchOvertime,
        handleChangeBrand,
        handleChangeBatchOvertime,
        handleChageTags,
    } = props

    let _timeOut = null

    const _handleChangeName = e => {
        const { value } = e.target

        if (_timeOut) clearTimeout(_timeOut)

        _timeOut = setTimeout(() => {
            handleChangeName(value)
        }, 500)
    }

    const _handleChange = e => {
        const { value } = e.target

        if (_timeOut) clearTimeout(_timeOut)

        _timeOut = setTimeout(() => {
            handleChageUserCreate(value)
        }, 500)
    }

    const _handleChangeDate = (field, value) => {
        const cloneFilter = Object.assign({}, startCreate)

        cloneFilter[field] = value

        if (value.from === '' || value.to === '') {
            delete cloneFilter[field]
        }

        handleChangeDate(field,cloneFilter)
    }

    const _handleChangeField = (name, value) => {
        handleChangePartner(value.trim())
    }

    const getOptionOverTime = (start, end) => {
        const Options = []
        for (let i = start; i <= end; i++) {
            if(i !==0){
                const Option = {
                    name: i,
                    value: i,
                }
                Options.push(Option)
            }
        }
        return Options
    }

    const disableNoBrand = !!brand && brand.length>0 && !brand.includes('no brand')
    const disableOptionBrand = !!brand && brand.length>0 && brand.includes('no brand')

    return (
        <div className='FilterItemPieceError'>
            <div className='row align-items-starts'>
                <div className='FilterNameBatch col-12 col-xl-2 mb-3'>
                    <label className="font-weight-bold">Tên lô</label>
                    <div className='SearchField'>
                        <Search
                            placeholder='Tìm kiếm theo tên Lô...'
                            onChange={_handleChangeName}
                            allowClear={true}
                        />
                    </div>
                </div>
                <div className='FilterNameBatch col-12 col-xl-2 mb-3'>
                    <label className="font-weight-bold">Người tạo lô</label>
                    <div className='SearchField'>
                        <Search
                            placeholder='Tìm kiếm theo người tạo...'
                            onChange={_handleChange}
                            allowClear={true}
                        />
                    </div>
                </div>
                <BatchesPartner
                    onChangePartner={_handleChangeField}
                />
                <div className='col-12 col-xl-2 mb-3'>
                    <label className="font-weight-bold">Ngày tạo lô</label>
                    <FilterDateRangeV2
                        field='created_at'
                        onDatesChange={_handleChangeDate}
                    />
                </div>
                <div className='col-12 col-xl-2 mb-3'>
                    <label className="font-weight-bold">Độ ưu tiên</label>
                    <Select
                        onChange={(value) => handleChagePriority(value)}
                        defaultValue={''} style={{ width: '100%' }}>
                        <Option value=''>Tất cả</Option>
                        <Option value='3'>Cao nhất</Option>
                        <Option value='2'>Cao</Option>
                        <Option value='1'>Bình thường</Option>
                    </Select>
                </div>
                <div className='col-12 col-xl-2 mb-3'>
                    <SelectFilterOptions
                        defaultValue={[]}
                        mode="multiple"
                        listOptions={TAGS}
                        style={{ width: '100%' }}
                        field="tags" label="Tags"
                        placeholder='Chọn tag'
                        allowClear
                        handleChange={handleChageTags}
                        isMultiple={true}
                    />
                </div>
                <div className='col-12 col-xl-4 mb-3'>
                    <label className="font-weight-bold">Loại sản phẩm</label>
                    <FilterProductType
                        productTypes={productTypes}
                        onChangeProductType={handleChangeProductType}
                    />
                </div>
                <div className='col-12 col-xl-2 mb-3'>
                    <label className="font-weight-bold">Ngày cắt</label>
                    <FilterDateRangeV2 field='startCuttingAt' onDatesChange={_handleChangeDate} showTime={true} />
                </div>
                
                <div className='col-12 col-xl-2 mb-3'>
                <label for="request_update" className="d-block w-100 font-weight-bold">Brand</label>
                    <Select
                        name='brand'
                        className='brand'
                        mode={'multiple'}
                        onChange={(value) => handleChangeBrand(value)}
                        value={brand}
                        allowClear
                        placeholder='Chọn brand name'
                        style={{ width: '100%'}}
                    >
                        <Option disabled={disableNoBrand} value='no brand'> No brand</Option>
                        {listBrand.length && listBrand.map((i, index) => (
                            <Option disabled={disableOptionBrand} value={i.value} key={index}>{i.label}</Option>
                        ))
                        }
                    </Select>
                </div>
                <div className='col-12 col-xl-2 mb-3'>
                    <SelectFilterOptions
                        defaultValue={batchOvertime}
                        className='Overtime'
                        name='batch_overtime'
                        listOptions={getOptionOverTime(-6, 6)}
                        style={{ width: '100%' }}
                        field="batch_overtime" label="Thời gian item quá hạn"
                        handleChange={handleChangeBatchOvertime}
                        mode='multiple'
                        allowClear
                        placeholder='Chọn thời gian item quá hạn'
                    />
                </div>
            </div>
        </div>
    )
}

export default FilterItemPieceError